import React from "react";
import { Link } from "Components/Base/Navigation/Link";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { default as MUIBreadCrumbs } from "@mui/material/Breadcrumbs";
import { HomeIcon } from "Components/Icons";

const BreadCrumbs = ({ crumbs }) => {
  return (
    <MUIBreadCrumbs aria-label="breadcrumb" data-testid="breadcrumb-component">
      <Link color="inherit" href="/">
        <HomeIcon />
      </Link>
      {crumbs &&
        crumbs.map((crumb, index) => {
          return index === crumbs.length - 1 ? (
            <Typography color="textPrimary" key={"crumb-" + index}>
              {crumb.title}
            </Typography>
          ) : (
            <Link color="inherit" key={"crumb-" + index} href={crumb.href}>
              {crumb.title}
            </Link>
          );
        })}
    </MUIBreadCrumbs>
  );
};

export default BreadCrumbs;
